import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Helpers } from '../../../helpers';

declare let mLayout: any;
@Component({
    selector: "app-aside-nav",
    templateUrl: "./aside-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class AsideNavComponent implements OnInit, AfterViewInit {

    path: string;
    constructor(public router: Router) {
        this.path = Helpers.getPath();
    }

    ngOnInit() {

    }

    ngAfterViewInit() {
        mLayout.initAside();
    }

    goToHomePage() {
        this.router.navigate(["/" + this.path]);
    }
}


// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/layouts/aside-nav/aside-nav.component.ts